import { Outlet } from 'react-router-dom';

import { DefaultLayout } from '@/layouts/DefaultLayout';

export const AdminLayout = () => {
  return (
    <DefaultLayout>
      <div>
        <Outlet />
      </div>
    </DefaultLayout>
  );
};
